if (!customElements.get('mystery-box-cart-item-upsell')) {
  customElements.define(
    'mystery-box-cart-item-upsell',
    class mysteryBoxCartItemUpsell extends HTMLElement {
      constructor() {
        super();

        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.button = this.querySelector('.custom-button');
        this.spinner = this.querySelector('.custom-button--spinner.loading__spinner');
        this.textInButton = this.querySelectorAll('.text-in-button');

        this.lineItemVariantID = this.getAttribute('data-item-variant-id');
        this.lineItemVariantQuantity = this.getAttribute('data-item-variant-quantity');

        this.button.addEventListener('click', this.handleUpsell.bind(this));

        const productInfo = document.querySelector('#mysteryBoxCartInfo')
          ? JSON.parse(document.querySelector('#mysteryBoxCartInfo').innerText)
          : null;
        this.container = this.querySelector(".mystery-box-cart-drawer-item-upsell");

        // Concern: This is dependant on variants being in the right order
        this.variantsMap = this.buildVariantsMap(productInfo);
        this.mysteryBoxUpgradeVariant = this.variantsMap[parseInt(this.lineItemVariantID)];

        this.checkIfUpSellBlockShouldShow();
      }

      buildVariantsMap(items) {
        //create a map of the variant that should be added for the current selected variants
        //ie the upsell that should be added for the current selected variant
        const map = {};

        items
          .map((item, index, arr) => {
            if (index % 2 === 0 && arr[index + 1]) {
              return [item.id, arr[index + 1]];
            }
            return null;
          })
          .filter(Boolean)
          .forEach((pair) => {
            map[pair[0]] = pair[1];
          });

        return map;
      }

      checkIfUpSellBlockShouldShow() {
        //check if matching id has stock
        if (this.mysteryBoxUpgradeVariant.available) {
          this.container.classList.remove('hidden');
        }
      }

      handleUpsell() {
        this.updateCartWithUpsell(
          this.lineItemVariantID,
          this.lineItemVariantQuantity,
          this.mysteryBoxUpgradeVariant.id
        );
      }

      updateCartWithUpsell(removeVariantId, quantity, addVariantId) {
        // Remove the specified quantity of the existing item
        let removeFormData = new FormData();
        removeFormData.append('id', removeVariantId);
        removeFormData.append('quantity', 0); // Set to 0 to remove the item entirely
        if (this.cart) {
          removeFormData.append(
            'sections',
            this.cart
              .getSectionsToRender()
              .map((section) => section.id)
              .join(',')
          );
        }
        removeFormData.append('sections_url', window.location.pathname);

        this.querySelector('.text-content').classList.add('hidden');
        this.querySelector('.mystery-box-spinner-cart-item.loading__spinner').classList.remove('hidden');

        fetch(window.Shopify.routes.root + 'cart/change.js', {
          method: 'POST',
          body: removeFormData,
        })
          .then((response) => response.json())
          .then(() => {
            // Add the new item
            let addFormData = new FormData();
            addFormData.append('id', addVariantId);
            addFormData.append('quantity', quantity);
            if (this.cart) {
              addFormData.append(
                'sections',
                this.cart
                  .getSectionsToRender()
                  .map((section) => section.id)
                  .join(',')
              );
            }
            addFormData.append('sections_url', window.location.pathname);

            fetch(window.Shopify.routes.root + 'cart/add.js', {
              method: 'POST',
              body: addFormData,
            })
              .then((response) => response.json())
              .then((response) => {
                this.querySelector('.text-content').classList.remove('hidden');
                this.querySelector('.custom-button').classList.add('no-pointer-events');
                this.querySelector('.mystery-box-spinner-cart-item.loading__spinner').classList.add('hidden');
                this.cart.renderContents(response);
              })
              .catch((error) => {
                console.error('Error adding item:', error);
              });
          })
          .catch((error) => {
            console.error('Error removing item:', error);
          });
      }
    }
  );
}
